import { Repository } from '../../repositories/abstraction';
import { ReadonlyRepositoryObjectService, RepositoryObjectServiceOptions } from './readonly-repository-object.service';

export abstract class RepositoryObjectService<T, TResult, TQueryParams, TCrudParams> extends ReadonlyRepositoryObjectService<T, TResult, TQueryParams>{


  constructor(protected override repository: Repository<T, TResult, TQueryParams, TCrudParams>,
              options: RepositoryObjectServiceOptions<T> = {}) {
    super(repository, options);
  }

  async create(value: T, params: TCrudParams): Promise<T> {
    const response = await this.repository.create(value, params);
    const result = this.getValue(response);
    this.value.set(result);
    return result;
  }

  async update(value: T, params: TCrudParams): Promise<T> {
    const response = await this.repository.update(value, params);
    const result = this.getValue(response);
    this.value.set(result);
    return result;
  }

  async createOrUpdate(value: T, params: TCrudParams): Promise<T> {
    const response = this.value() ? await this.repository.update(value, params) : await this.repository.create(value, params);
    const result = this.getValue(response);
    this.value.set(result);
    return result;
  }

  async patch(value: Partial<T>, params: TCrudParams): Promise<T> {
    const response = await this.repository.patch(value, params);
    const result = this.getValue(response);
    this.value.set(result);
    return result;
  }

  async delete(params: TCrudParams): Promise<T> {
    const response = await this.repository.delete(params);
    const result = this.getValue(response);
    this.value.set(undefined);
    return result;
  }
}
